import { mutationOptions, queryOptions } from "@tanstack/react-query";
import { setTrustLoginHint } from "./trustLoginHint";
import { TRUST_PATHS } from "./paths";
import z from "zod";
import { trustAPI } from "./trustBaseApiClient";
import { queryClient } from "../api/queryClient";

export const requestCodeMutationOptions = () =>
  mutationOptions({
    mutationFn: (payload: { email: string }) => trustAPI.post("auth/otp/request", payload),
  });

export const verifyCodeMutationOptions = ({ returnUrl }: { returnUrl: string }) =>
  mutationOptions({
    mutationFn: (payload: { email: string; code: string }) => trustAPI.post("auth/otp/verify", payload),
    onSuccess: () => {
      setTrustLoginHint(true);
      location.replace(returnUrl);
    },
    meta: { skipErrorLogging: true },
  });

export const logoutMutationOptions = () =>
  mutationOptions({
    mutationFn: () => trustAPI.post("auth/logout", {}),
    onSuccess: async () => {
      setTrustLoginHint(false);
      location.replace(TRUST_PATHS.login());
    },
  });

const csrfTokenQueryOptions = () =>
  queryOptions({
    queryKey: ["csrf-token"],
    queryFn: () => trustAPI.get(`auth/csrf-token`, { schema: z.object({ csrfToken: z.string() }) }),
    throwOnError: true,
    staleTime: Infinity,
  });

export const getCsrfToken = async () => {
  const { csrfToken } = await queryClient.ensureQueryData(csrfTokenQueryOptions());
  return csrfToken;
};
